import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AlertController, ModalController, IonicModule, ToastController } from '@ionic/angular';
import { ToastService } from '../../../../services/toast.service';
import { ILocation } from '../../../../models/location';
import { IBeverage } from '../../../../models/beverage';


import * as fromUser from 'app/state/user';
import * as fromLocation from "app/state/location";
import * as fromBeverage from "app/state/beverage";
import * as fromUnits from "app/state/units";
import * as fromKeg from "app/state/keg";
import { Store } from '@ngrx/store';
import { IKeg, IKegVM } from 'app/models/keg';
import { ICan } from 'app/models/can';
import { IBottle } from 'app/models/bottle';
import * as fromBottle from 'app/state/bottle';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KegComponent } from './keg/keg.component';
import * as fromCan from 'app/state/can';
import * as fromCo2 from 'app/state/co2-bottle';
import { ICO2Bottle } from 'app/models/co2-bottle';
import { FormComponent } from './form/form.component';
import { CanComponent } from './can/can.component';
import { BottleComponent } from './bottle/bottle.component';
import { LocationCo2Component } from './co2/co2.component';
import { HelpModalComponent } from 'app/components/help-modal/help-modal.component';



@Component({
  selector: 'app-location-detail',
  templateUrl: './location-detail.page.html',
  styleUrls: ['./location-detail.page.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule,
    KegComponent,
    FormComponent,
    CanComponent,
    BottleComponent,
    LocationCo2Component
],
})
export class LocationDetailPage {

  barId = this.store.selectSignal(fromUser.selectBarId);
  userId = this.store.selectSignal(fromUser.selectUserId);
  items = this.store.selectSignal(fromLocation.selectAllItems);
  allKegs = this.store.selectSignal(fromKeg.getKegsWithUnitBeverageAndLocation);
  allBeverages = this.store.selectSignal(fromBeverage.selectAllItems);
  unitTypes = this.store.selectSignal(fromUnits.getUnits);
  item = this.store.selectSignal(fromLocation.selectCurrentItem);
  bottles = this.store.selectSignal(fromBottle.selectAllItemsFromCurrentLocation);
  cans = this.store.selectSignal(fromCan.selectAllItemsFromCurrentLocation);
  kegs2 = this.store.selectSignal(fromKeg.selectAllItemsFromCurrentLocation)
  co2s = this.store.selectSignal(fromCo2.selectAllItemsFromCurrentLocation)

  constructor(
    private store: Store,
    private router: Router,
    public alertController: AlertController,
    public toastController: ToastController,
    public toastService: ToastService,
    public modalController: ModalController
  ) { }

  searchQuery!: string;
  shouldShowCancel!: boolean;

  oldContent!: ILocation;
  beverages: IBeverage[] = [];
  kegs: IKegVM[] = [];


  softUpdateLocation(event: any) {
    this.store.dispatch(fromLocation.softUpdate({ id: event.id, data: event.data, uid: event.uid }));
  }



  async confirmAlert(id: string, uid: string) {
    const alert = await this.alertController.create({
      header: 'Confirm!',
      message: 'Are you sure you want to delete?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
        },
        {
          text: 'Okay',
          handler: () => {
            this.delete(id, uid);
          },
        },
      ],
    });

    await alert.present();
  }

  tracById(index: number, item: any) {
    return item.id;
  }


  onSearch(event: any) {

    // ?? [] : JSON.stringify(undefined) === undefined → JSON.parse(undefined)
    // threw "Unexpected identifier undefined" when the signals were empty
    // (Sentry BAR-HELPER-2Q7).
    this.beverages = JSON.parse(JSON.stringify(this.allBeverages() ?? []));
    // this.bottles = JSON.parse(JSON.stringify(this.allBottles));
    this.kegs = JSON.parse(JSON.stringify(this.allKegs() ?? []));

    const searchTerm = event.srcElement.value;

    if (!searchTerm) {
      return;
    }

    if (this.beverages) {
      this.beverages = this.beverages.filter((item: IBeverage) => {
        if (searchTerm) {
          let nameOk = false;
          if (item.name) {
            nameOk = (item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1);
          }
          return nameOk;
        }
        return false;
      });
    }

    if (this.kegs) {
      this.kegs = this.kegs.filter((item: IKegVM) => {
        if (searchTerm) {

          let nameOk = false;
          nameOk = (item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1);

          if (!nameOk && !!item.beverage?.name) {
            nameOk = (item.beverage.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1);
          }
          return nameOk;
        }
        return false;
      });
    }
  }

  private async delete(id: string, uid: string) {

    this.allKegs().map((keg) => {
      if (keg.id && keg.locationId === id) {
        const update: Partial<IKeg> = {
          locationId: '',
        }
        this.store.dispatch(fromKeg.softUpdate({ id: keg.id, data: update, uid: uid }))
      }
    });

    if (this.bottles() && this.bottles().length > 0) {
      this.bottles().forEach((bottle: IBottle) => {
        if (bottle.id && bottle.locationId === id) {
          const update: Partial<IBottle> = {
            locationId: '',
          }
          this.store.dispatch(fromBottle.softUpdate({ id: bottle.id, data: update, uid: uid }))
        }
      });
    }

    if (this.cans() && this.cans().length > 0) {
      this.cans().forEach((can: ICan) => {
        if (can.id && can.locationId === id) {
          const update: Partial<ICan> = {
            locationId: '',
          }
          this.store.dispatch(fromCan.softUpdate({ id: can.id, data: update, uid: uid }))
        }
      });
    }

    this.co2s().forEach((co2) => {
      if (co2.id && co2.locationId === id) {
        const update: Partial<ICO2Bottle> = { locationId: null };
        this.store.dispatch(fromCo2.softUpdate({ id: co2.id, data: update, uid: uid }));
      }
    });

    this.store.dispatch(fromLocation.deleteItem({ id }))
    this.router.navigate(['/inventory/location']);
  }



  async removeBeverage(beverage: IBeverage) {
    const update: Partial<IBeverage> = {
      locationId: '',
      locationName: ''
    }
    this.store.dispatch(fromBeverage.softUpdate({ id: beverage?.id ?? '', data: update, uid: this.userId()! }))
    await this.toastService.saveSuccess();
  }

  public async openHelpModal() {
    const modal = await this.modalController.create({
      component: HelpModalComponent,
      componentProps: {
        component: 'LocationDetailPage'
      }
    });
    return await modal.present();
  }

}
